import { render, staticRenderFns } from "./TransfersCompanies.vue?vue&type=template&id=ce7fa1e6&"
import script from "./TransfersCompanies.vue?vue&type=script&lang=js&"
export * from "./TransfersCompanies.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\escal\\Projects\\Betterway.Vms\\Betterway.VMS.web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ce7fa1e6')) {
      api.createRecord('ce7fa1e6', component.options)
    } else {
      api.reload('ce7fa1e6', component.options)
    }
    module.hot.accept("./TransfersCompanies.vue?vue&type=template&id=ce7fa1e6&", function () {
      api.rerender('ce7fa1e6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/TransfersCompanies.vue"
export default component.exports